import React, { useEffect, useRef, useState } from "react";
import * as S from "./style";

import IconDown from "assets/images/icon_down.png";
import IconMobile from "assets/images/icon_hamburger.png";
import Logo from "assets/images/logo.png";
import MobileClose from "assets/images/mobile_close.png";
import MobileDown from "assets/images/mobile_down.png";
import MobileUp from "assets/images/mobile_up.png";
import { UrlInternal } from "common/constants/endpoints";
import useWindowSize, { Size } from "hooks/useWindowSize";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { saveLocalStorage } from "utils/localStorage";
import { LANG } from "utils/localStorage/type";

const DataMenu = [
  {
    text: "YEOLMAE",
    routes: UrlInternal.HOME,
    subMenu: [
      {
        text: "BUSINESS",
        routes: UrlInternal.HOME,
        link: "business",
      },
      {
        text: "ABOUT",
        routes: UrlInternal.HOME,
        link: "about",
      },
      {
        text: "HISTORY",
        routes: UrlInternal.HOME,
        link: "history",
      },
    ],
  },
  {
    text: "PARTNERS",
    routes: UrlInternal.HOME,
    link: "partners",
  },
  {
    text: "NEWS",
    routes: UrlInternal.HOME,
    link: "news",
  },
  {
    text: "CONTACT",
    routes: UrlInternal.HOME,
    link: "contact",
  },
];

const DataSelect = [
  {
    text: "KOR",
    lang: "kr",
  },
  {
    text: "ENG",
    lang: "en",
  },
];

const DataLangMobile = ["kr", "en"];

function Header() {
  const [visibleSelect, setVisibleSelect] = useState(false);
  const history = useHistory();
  const size: Size = useWindowSize();
  const checkSize = size.width && size.width > 768;
  const checkBusiness = size.width && size.width <= 1024;
  const [openMenu, setOpenMenu] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const { t, i18n } = useTranslation("common");
  const wrapperRef = useRef(null);
  const menuRef = useRef(null);
  useOutsideAlerter(wrapperRef, setVisibleSelect);
  useOutsideAlerter(menuRef, setOpenMenu);

  function useOutsideAlerter(ref: any, setVisible: any) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          setVisible(false);
          document.body.style.overflow = "auto";
          document.body.style.touchAction = "auto";
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, setVisible]);
  }

  const ScrollToCenter = (id: string) => {
    const element = document.getElementById(id);
    const rect = element?.getBoundingClientRect();
    const x = rect?.top;
    const scrollTop = document.documentElement.scrollTop
      ? document.documentElement.scrollTop
      : document.body.scrollTop;
    if (x) {
      window.scroll({
        top: id === "business" ? scrollTop + x - 60 : scrollTop + x - 50,
        behavior: "smooth",
      });
    }
  };

  const ScrollToCenterMobile = (id: string) => {
    const element = document.getElementById(id);
    const rect = element?.getBoundingClientRect();
    const x = rect?.top;
    const scrollTop = document.documentElement.scrollTop
      ? document.documentElement.scrollTop
      : document.body.scrollTop;
    if (x) {
      window.scroll({
        top:
          id === "business" && checkBusiness
            ? scrollTop + x - 50
            : scrollTop + x + 20,
        behavior: "smooth",
      });
    }
  };

  const scrollToTop = () => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <S.Container>
      <div className="wp-header">
        <div className="header">
          <div className="logo" onClick={scrollToTop}>
            <img src={Logo} alt="logo" />
          </div>
          {checkSize ? (
            <div className="menu">
              {DataMenu.map((data, index) => (
                <div
                  className="menu--item"
                  onClick={() => history.push(data.routes)}
                  key={index}
                >
                  <div
                    onClick={() => {
                      if (data.link) {
                        ScrollToCenter(data.link);
                      }
                    }}
                  >
                    {data.text}
                  </div>
                  {data.subMenu && (
                    <div className="wp--sub__menu">
                      {data.subMenu.map((dt, i) => (
                        <div
                          className="sub-menu"
                          key={i}
                          onClick={() => ScrollToCenter(dt.link)}
                        >
                          {dt.text}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
              <div className="select" ref={wrapperRef}>
                <div
                  className="content"
                  onClick={() => setVisibleSelect((prev) => !prev)}
                >
                  <div>
                    {i18n.language === "kr"
                      ? DataSelect[0].text
                      : DataSelect[1].text}
                  </div>
                  <img src={IconDown} alt="icon down" />
                </div>
                {visibleSelect && (
                  <div className="option">
                    {DataSelect.map((item, index) => (
                      <div
                        key={index}
                        onClick={() => {
                          setVisibleSelect(false);
                          i18next.changeLanguage(item.lang);
                          saveLocalStorage(LANG, item.lang, 7);
                        }}
                      >
                        {item.text}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="box-mobile">
              <img
                src={IconMobile}
                alt="icon mobile"
                onClick={() => {
                  setOpenMenu(true);
                  document.body.style.overflow = "hidden";
                  document.body.style.touchAction = "none";
                }}
              />
              <div
                className={`menu-mobile ${openMenu ? "menu-mobile__open" : ""}`}
              >
                <div className="item-menu__mobile" ref={menuRef}>
                  <div>
                    <img
                      src={MobileClose}
                      alt="icon close"
                      onClick={() => {
                        setOpenMenu(false);
                        document.body.style.overflow = "auto";
                        document.body.style.touchAction = "auto";
                      }}
                      className="icon-close"
                    />
                  </div>
                  <div className="dropdown">
                    <div
                      className="dropdown--default"
                      onClick={() => setDropdown(!dropdown)}
                    >
                      <div>YEOLMAE</div>
                      <img
                        src={MobileDown}
                        alt="icon dropdown"
                        className={dropdown ? "img-up" : ""}
                      />
                    </div>
                    {dropdown && (
                      <div className="dropdown--option">
                        {DataMenu[0].subMenu?.map((item, index) => (
                          <div
                            key={index}
                            onClick={() => {
                              setVisibleSelect(false);
                              ScrollToCenterMobile(item.link);
                              setOpenMenu(false);
                              document.body.style.overflow = "auto";
                              document.body.style.touchAction = "auto";
                            }}
                          >
                            {item.text}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  {DataMenu.map(
                    (data, index) =>
                      index !== 0 && (
                        <div
                          key={index}
                          onClick={() => {
                            if (data.link) {
                              ScrollToCenterMobile(data.link);
                              setOpenMenu(false);
                              document.body.style.overflow = "auto";
                              document.body.style.touchAction = "auto";
                            }
                          }}
                        >
                          {data.text}
                        </div>
                      )
                  )}

                  <div className="wp-lang">
                    {DataLangMobile.map((data, index) => (
                      <div
                        className={`lang ${
                          i18n.language === data ? "lang-active" : ""
                        }`}
                        key={index}
                        onClick={() => {
                          i18next.changeLanguage(data);
                          setOpenMenu(false);
                          document.body.style.overflow = "auto";
                          document.body.style.touchAction = "auto";
                        }}
                      >
                        {data}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </S.Container>
  );
}

export default Header;
